module.exports = __webpack_public_path__ + "static/media/reliance-health-logo-white.32bcb03a.svg";